import React from 'react';
import { Button, ButtonColor, ButtonVariant, FormTemplate, IconType, TextInput } from 'ui-builder';
import { CreateEmailDomainRequest, EmailDomain, useEmailDomainsService } from 'nekst-api';
import { usePopupFormManager } from 'features/nekst-widgets';
import { DomainSetUpWalkthroughPopup } from './DomainSetUpWalkthrough';

export function CreateEmailDomainForm(props: { afterSubmitFunc?: () => void }) {
  const emailDomainsService = useEmailDomainsService();

  const popupFomManager = usePopupFormManager();

  return (
    <FormTemplate<CreateEmailDomainRequest, EmailDomain>
      title="Add New Email Domain"
      submitFormFunc={async (data) => {
        const result = await emailDomainsService.createTeamDomain(data);
        if (props.afterSubmitFunc) {
          props.afterSubmitFunc();
        }

        return result;
      }}
      afterSubmitFunc={async (result: EmailDomain) => {
        setTimeout(() => {
          popupFomManager.openForm(
            <DomainSetUpWalkthroughPopup domain={result} />
          );
        }, 1000);
      }}
      validationSchema={{
        domain: {
          type: 'string',
          constraints: {
            required: true,
            domain: true,
          },
        },
      }}
    >
      <TextInput source="domain" label="Domain" />
    </FormTemplate>
  );
}


export function CreateEmailDomainButton() {
  const popupFormManager = usePopupFormManager();

  return (
    <Button
      text="Add Domain"
      onClick={() => popupFormManager.openForm(<CreateEmailDomainForm />)}
      color={ButtonColor.BLUE}
      variant={ButtonVariant.FILLED}
      iconType={IconType.PLUS}
    />
  );
}
